import { Navigate, useRoutes } from 'react-router-dom';

import MainLayout from 'src/layouts/main';

import { authRoutes } from './auth';
import { doctorRoutes } from './doctor';
import { patientRoutes } from './patient';
import { publicoRoutes } from './publico';
import { medicoreRoutes } from './medicore';
import { jobPortalRoute } from './portal-job';
import { HomePage, mainRoutes } from './main';
import { emergencyRoutes } from './emergency';
import { medicoreFinanceRoutes } from './finance';
import { medicoreInventoryRoutes } from './inventory';
import { medicoreInsuranceRoutes } from './insurance';
import { configurationRoutes } from './configuration';
import { patientPortalRoutes } from './portal-patient';
import { medicoreHumanResourcesRoutes } from './human-resources';
import { medicoreUserManagementRoutes } from './user-management';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },

    // Auth routes
    ...authRoutes,

    // Dashboard routes
    ...medicoreRoutes,

    // Patient routes
    ...patientRoutes,

    // Emergency routes
    ...emergencyRoutes,

    // Inventory routes
    ...medicoreInventoryRoutes,

    // Finance routes
    ...medicoreFinanceRoutes,

    // Main routes
    ...mainRoutes,

    // Insurance routes
    ...medicoreInsuranceRoutes,

    // Insurance routes
    ...medicoreHumanResourcesRoutes,

    // Configuration routes
    ...configurationRoutes,
    // User management routes
    ...medicoreUserManagementRoutes,

    // Doctor routes
    ...doctorRoutes,

    // Patient portal routes
    ...patientPortalRoutes,

    ...jobPortalRoute,

    // Verificación pública de documentos (receta): anónima y sin guardas.
    ...publicoRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
